import React from 'react';

class Kitchen extends React.Component {
    render() {
        return <section></section>
    }
}

export default Kitchen;


// WEBPACK FOOTER //
// ./src/components/examples/kitchen.js